import { format, formatDistanceToNow } from 'date-fns';
import { enUS } from 'date-fns/locale/en-US';

export function formatDate(iso: string): string {
  return format(new Date(iso), 'y MMM d, HH:mm', { locale: enUS });
}

export function formatDateRelative(iso: string): string {
  return formatDistanceToNow(new Date(iso), { addSuffix: true, locale: enUS });
}
